import { useId } from "react";

interface Props {
  label: string;
  type: "text" | "email" | "password";
  value: string;
  autoComplete: string;
  onChange: (value: string) => void;
  describedBy?: string | undefined;
  required?: boolean;
}

export function TextField({
  label,
  type,
  value,
  autoComplete,
  onChange,
  describedBy,
  required = true,
}: Props) {
  const id = useId();
  return (
    <div className="flex flex-col gap-1.5">
      <label className="text-sm font-medium text-ink" htmlFor={id}>
        {label}
      </label>
      <input
        className="rounded-2xl border border-line bg-page px-4 py-2.5 text-sm text-ink transition-colors placeholder:text-ink-faint focus:border-accent"
        id={id}
        name={type === "password" ? "password" : "email"}
        type={type}
        autoComplete={autoComplete}
        required={required}
        value={value}
        aria-describedby={describedBy}
        onChange={(e) => onChange(e.target.value)}
      />
    </div>
  );
}
